import React from 'react';
import {LessonPresentation} from '../../../data/models/Course/LessonPresentation';
import {videoPlaybackText} from '../videoPlaybackText';

interface Props {
  lessonPresentation: LessonPresentation;
  currentLessonId: string;
  isMicroreel?: boolean;
}

const VideoPlaybackDetails = React.memo(
  ({lessonPresentation, currentLessonId, isMicroreel}: Props) => {
    return (
      <div className="VideoPlaybackDetails">
        <div className="InfoContainer">
          {lessonPresentation.organization.avatar && (
            <img
              src={lessonPresentation.organization.avatar}
              alt="avatar"
              className="Avatar"
            />
          )}
          <h5 className="Title">{lessonPresentation.organization.name}</h5>
          {lessonPresentation.course && (
            <h5 className="Title">
              {isMicroreel
                ? videoPlaybackText.microreel
                : videoPlaybackText.course}
              {lessonPresentation.course.title}
            </h5>
          )}
        </div>
        <h3>
          {
            lessonPresentation.lessons.find(item => item.id === currentLessonId)
              ?.title
          }
        </h3>
        <div className="VideoDescriptionContainer">
          <h5>{lessonPresentation.currentLesson.description}</h5>
        </div>
      </div>
    );
  },
);

export default VideoPlaybackDetails;
